import styled from '@emotion/styled';
import { tokens, Alert } from '@hotjar/hotsauce';

export const DowngradeMessage = {
  MessageContainer: styled.div`
    margin-top: ${tokens.spacer.x2pt5};
    li + li {
      margin-top: ${tokens.spacer.x1};
    }
  `,
  Alert: styled(Alert)`
    max-width: 600px;
    margin-top: ${tokens.spacer.x3};
  `,
};
